import React, { useState, useEffect } from 'react'
import { ContaminantHeatmap } from '../components/ContaminantHeatmap'
import { Navigation } from '../components/landing/Navigation'
import { Footer } from '../components/landing/Footer'
import { DonateModal } from '../components/landing/DonateModal'
import { TestResult, FormulaTarget } from '../types'
import { Loader2 } from 'lucide-react'
import axios from 'axios'

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:3001'

function Dashboard() {
  const [testResults, setTestResults] = useState<TestResult[]>([])
  const [formulaTargets] = useState<FormulaTarget[]>([])
  const [isLoading, setIsLoading] = useState(true)
  const [isDonateModalOpen, setIsDonateModalOpen] = useState(false)

  const fetchData = async () => {
    setIsLoading(true)
    try {
      const response = await axios.get(`${API_URL}/api/test_results`)
      // Ensure we always set an array
      const results = Array.isArray(response.data) ? response.data : []
      setTestResults(results)
    } catch (error) {
      console.error('Error fetching data:', error)
      setTestResults([]) // Set empty array on error
    } finally {
      setIsLoading(false)
    }
  }

  useEffect(() => {
    fetchData()
  }, [])

  return (
    <div className="min-h-screen bg-background">
      <Navigation onDonateClick={() => setIsDonateModalOpen(true)} />

      <main className="container mx-auto px-4 py-8">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 pt-6 pb-12 text-center">
          <h1 className="text-2xl md:text-3xl font-normal leading-tight text-foreground">
            You are what you eat. So is your baby.{" "}
            <span className="text-muted-foreground">We tested formula for heavy metals, toxins, macronutrients, and contaminants.</span>
          </h1>
        </div>

        {isLoading ? (
          <div className="flex items-center justify-center py-12">
            <Loader2 className="h-8 w-8 animate-spin text-blue-600" />
            <span className="ml-2 text-gray-600">Loading...</span>
          </div>
        ) : (
          <ContaminantHeatmap data={testResults} formulaTargets={formulaTargets} />
        )}
      </main>

      <Footer />

      <DonateModal 
        isOpen={isDonateModalOpen}
        onClose={() => setIsDonateModalOpen(false)}
      />
    </div>
  )
}

export default Dashboard
